/** biome-ignore-all lint/nursery/useExplicitType: Zod schema inference */
import { z } from 'zod';
import type { IAPI } from '../../apiResponse';
import { createApiResponseSchema } from '../../apiResponse';
import { wordTimingSchema } from '../shared/word-timing-schema';

export const getTitleAudioV2ResultSchema = z.object({
  audioUrl: z.string(),
  wordTimings: z.array(wordTimingSchema).optional(),
});

export type IGetTitleAudioV2Result = z.infer<typeof getTitleAudioV2ResultSchema>;

export const getTitleAudioV2ResponseSchema = createApiResponseSchema(
  getTitleAudioV2ResultSchema,
) as z.ZodSchema<IAPI<IGetTitleAudioV2Result>>;

export type IGetTitleAudioV2Response = IAPI<IGetTitleAudioV2Result>;
